const thousand = "k"

export const formatNumberOfFollowers = (numberOfFollowers: number): string => {
    if (numberOfFollowers < 1000) {
        return numberOfFollowers.toString()
    }
    return `${(numberOfFollowers / 1000).toFixed(1)}${thousand}`
}
